// extracted by mini-css-extract-plugin
module.exports = {"footer":"layout_footer__lldqG","main":"layout_main__WKREA"};